import React from "react";
import Layout from "Components/Layouts/Common/common";
import AboutClasses from "./extension.module.css";
import About3 from "Assets/About/about_3.png";
import Image1 from "Assets/About/about_1.png";
import About_2 from "Assets/About/about_2.png";
import AboutCard from "Components/AboutUs/Cards/Cards";
function About() {
    return (
        <Layout>
            <div className={AboutClasses["Container"]}>
                <header>
                    <h3>Extension of Tax Returns</h3>
                </header>
                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3>Tax Return Extension Services</h3>
                        <h4>Need More Time to File Your Taxes?</h4>
                        <p>
                            At <b>Serene Tax</b>, we understand that life can be
                            busy, and sometimes you need a little extra time to
                            file your tax return. That’s why we offer expert
                            assistance in filing tax return extensions to give
                            you the peace of mind and time you need to file
                            accurately.
                        </p>
                        <h4>What is a Tax Return Extension?</h4>
                        <p>
                            A tax return extension gives you additional time to
                            file your U.S. tax return. It’s important to note
                            that while an extension provides more time to submit
                            your tax return, it does not extend the time to pay
                            any taxes owed. If you owe taxes, they must still be
                            paid by the original filing deadline to avoid
                            penalties and interest.
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>Why File a Tax Return Extension?</h3>
                        <p>
                            Extra Time for Complex Returns: If you need more
                            time to gather documents, deductions, or complete
                            complex financial calculations, a tax extension
                            allows you the flexibility to do so.
                        </p>
                        <p>
                            Avoiding Penalties: Filing an extension prevents
                            late filing penalties, ensuring your tax return is
                            filed on time, even if it’s after the usual
                            deadline.
                        </p>
                        <p>
                            Reduced Stress: Sometimes life happens—whether it’s
                            work, travel, or unexpected events. An extension
                            gives you the space to manage your time without the
                            pressure of a looming deadline
                        </p>
                    </div>
                </div>{" "}
                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3>How Does a Tax Extension Work?</h3>
                        <p>
                            Automatic 6-Month Extension: The IRS allows
                            individuals and businesses to file for a 6- month
                            extension by submitting Form 4868 (for individuals)
                            or Form 7004 (for businesses). This grants
                            additional time to file your return, usually until
                            October 15th for individuals.
                        </p>

                        <p>
                            We Handle the Paperwork: At Serene Tax, we’ll
                            prepare and submit the extension forms for you,
                            ensuring everything is filed accurately and on time.
                        </p>
                        <p>
                            Extension Does Not Extend Payment Deadlines: While
                            the extension gives you more time to file, tax
                            payments are still due by the original deadline. If
                            you owe, we’ll help you estimate your tax liability
                            and suggest payment options to avoid penalties and
                            interest.
                        </p>
                        <p>
                            Time to Gather Documentation: If you're missing
                            crucial documents or need time to make tax-saving
                            decisions, an extension allows you to gather
                            everything you need for an accurate return.
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>{" "}
                <div
                    className={`${AboutClasses["section-1"]} ${AboutClasses["section-2"]}`}>
                    <img src={About3} alt="user" />
                    <div
                        className={AboutClasses["content"]}
                        style={{ gap: "0.6rem" }}>
                        <h3>
                            Why Choose Serene Tax for Your Tax Return Extension?
                        </h3>
                        <ul>
                            <li>
                                <b>Expert Guidance: </b>Our tax professionals
                                are well-versed in the extension process and
                                will ensure that all required forms are
                                submitted correctly and on time.
                            </li>
                            <li>
                                <b>Avoid Penalties:</b> By filing the extension
                                on your behalf, we help you avoid late filing
                                penalties and unnecessary complications
                            </li>
                            <li>
                                <b>Stress-Free Filing:</b> We’ll handle the
                                paperwork and deadlines for you, so you don’t
                                have to worry about missing an important tax
                                date.
                            </li>
                            <li>
                                <b>Timely Assistance:</b>
                                We understand the urgency of the tax extension
                                process. When you work with Serene Tax, you can
                                count on quick, professional service.
                            </li>
                            <li>
                                <b>Comprehensive Tax Services:</b>
                                We don't just file your extension—we’ll assist
                                with the preparation of your tax return once
                                you're ready to submit it, ensuring your taxes
                                are filed accurately and on time.
                            </li>
                        </ul>
                    </div>
                </div>{" "}
                <div className={AboutClasses["section-1"]}>
                    <div className={AboutClasses["content"]}>
                        <h3>How Does a Tax Extension Work?</h3>
                        <p>
                            Automatic 6-Month Extension: The IRS allows
                            individuals and businesses to file for a 6- month
                            extension by submitting Form 4868 (for individuals)
                            or Form 7004 (for businesses). This grants
                            additional time to file your return, usually until
                            October 15th for individuals.
                        </p>

                        <p>
                            We Handle the Paperwork: At Serene Tax, we’ll
                            prepare and submit the extension forms for you,
                            ensuring everything is filed accurately and on time.
                        </p>
                        <p>
                            Extension Does Not Extend Payment Deadlines: While
                            the extension gives you more time to file, tax
                            payments are still due by the original deadline. If
                            you owe, we’ll help you estimate your tax liability
                            and suggest payment options to avoid penalties and
                            interest.
                        </p>
                        <p>
                            Time to Gather Documentation: If you're missing
                            crucial documents or need time to make tax-saving
                            decisions, an extension allows you to gather
                            everything you need for an accurate return.
                        </p>
                    </div>
                    <img src={Image1} alt="user" />
                </div>{" "}
                <div
                    className={AboutClasses["section-1"]}
                    style={{
                        gridTemplateColumns: "1fr",
                        paddingTop: "1rem",
                        paddingBottom: "1rem",
                    }}>
                    <div className={AboutClasses["content"]}>
                        <h3>How to Get Started?</h3>
                        <p>
                            Filing a tax extension is a simple and effective way
                            to give yourself more time to file your taxes. Let
                            Serene Tax handle the details for you, so you can
                            focus on what matters most. Contact us today to get
                            started with your tax extension.{" "}
                            <b>Call [+1 (262) 735-8874/ +1 (262) 735-8875]</b>
                        </p>
                    </div>
                </div>{" "}
                <div
                    className={AboutClasses["section-1"]}
                    style={{
                        gridTemplateColumns: "1fr",
                        paddingTop: "1rem",
                        paddingBottom: "1rem",
                    }}>
                    <div className={AboutClasses["content"]}>
                        <h3>Frequently Asked Questions About Tax Extensions</h3>
                        <h4>1. How long does an extension give me?</h4>
                        <p>
                            A tax extension provides an additional 6 months to
                            file your return. For individuals, this generally
                            extends the filing deadline to October 15th
                        </p>
                        <h4>
                            2. Does an extension give me more time to pay my
                            taxes?
                        </h4>
                        <p>
                            No. An extension only extends the time to file your
                            return, not the time to pay any taxes owed. You must
                            still pay any taxes by the original deadline to
                            avoid penalties and interest.
                        </p>
                        <h4>
                            3. What happens if I don’t file for an extension?
                        </h4>
                        <p>
                            If you don’t file for an extension and miss the tax
                            deadline, you may be subject to late filing
                            penalties and interest on any taxes owed. Filing for
                            an extension avoids these penalties and ensures you
                            stay compliant.
                        </p>
                        <h4>
                            4. How do I know if I need to file an extension?
                        </h4>
                        <p>
                            If you're unable to gather all necessary documents,
                            need more time for your tax preparation, or can't
                            meet the deadline, filing an extension is the best
                            option. Our experts are here to help you decide.
                        </p>
                    </div>
                </div>{" "}
                <div
                    className={AboutClasses["section-1"]}
                    style={{
                        gridTemplateColumns: "1fr",
                        paddingTop: "1rem",
                        paddingBottom: "1rem",
                    }}>
                    <div className={AboutClasses["content"]}>
                        <h3>Take the First Step Toward Peace of Mind ?</h3>
                        <p>
                            Don’t let tax deadlines cause you stress—let Serene
                            Tax handle your extension filing and give you the
                            time you need to file accurately
                            <b>Call [+1 (262) 735-8874/ +1 (262) 735-8875]</b>
                        </p>
                    </div>
                </div>{" "}
            </div>
        </Layout>
    );
}

export default About;
